var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.sistemaSuspenso)?_c('sistema-suspenso',{attrs:{"titulo":_vm.suspensao.titulo,"mensagem":_vm.suspensao.mensagem}}):_c('router-view',{attrs:{"aviso-feriado-bancario":_vm.avisoFeriadoBancario}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }